import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { combineLatest } from "rxjs";
import { map } from "rxjs/operators";
import { EasyAuthService } from "@skills-app/core/services/easyauth.service";

export const roleGuard = (requiredRoles: string[]): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const easyAuth = inject(EasyAuthService);

    // Wait until auth readiness is true before deciding
    return combineLatest([easyAuth.isAuthReady(), easyAuth.getUser()]).pipe(
      map(([ready, user]) => {
        if (!ready) {
          // While auth is still bootstrapping, don't redirect.
          // Returning true here allows navigation to proceed; the app shell gating handles rendering.
          return true;
        }

        const isAuthed = user?.isAuthenticated === true;
        const roles = user?.roles ?? [];

        // If not authenticated, send to account help / sign-in guidance
        if (!isAuthed) {
          return router.parseUrl("/no-access");
        }

        const ok =
          requiredRoles.length === 0 ||
          requiredRoles.some((r) => roles.includes(r));

        // If authenticated but missing role → 403 page
        return ok ? true : router.parseUrl("/forbidden");
      }),
    );
  };
};
